import {CampaignProps} from '@/types/campaign';
import {BriefFieldManagerAttributes} from '@/views/campaigns/brief/brief-field-manager/BriefFieldManager';
import BriefField from '@/views/campaigns/brief/brief-field-manager/brief-field/BriefField';
import HashtagBriefItem from '@/views/campaigns/brief/brief-field-manager/brief-field/HashtagBriefItem';

class SwapMatchKeywords extends BriefField {
  briefFieldManager: BriefFieldManagerAttributes;

  constructor(
    briefFieldManager: BriefFieldManagerAttributes,
    campaignData: CampaignProps,
    key: string,
    value: any
  ) {
    super(briefFieldManager, campaignData, key, value);
    this.briefFieldManager = briefFieldManager;
  }

  set value(value: any) {
    super.value = value;
    if (this.briefFieldManager.fields.campaignHashtagBriefItem) {
      (
        this.briefFieldManager.fields
          .campaignHashtagBriefItem as HashtagBriefItem
      ).swapMatchKeywords = value;
    }
  }

  get value() {
    return super.value;
  }
}

export default SwapMatchKeywords;
